import Blockly from 'blockly';

class ParamManager {
  constructor() {
    this.types = [
      ['next positional parameter', 'next'],
      ['remaining parameters', 'rest'],
    ];

    this.params = [];
    this.onUpdate = () => {};
  }

  toSyntax() {
    let syntax = [];

    for (let param in this.params) {
      if (this.params[param].position === 'rest') {
        syntax.push('[' + this.params[param].name + '...]')
      } else {
        syntax.push('[' + this.params[param].name + ']')
      }
    }

    return syntax.join(' ');
  }

  getNextParamName() {
    return `param${this.params.length+1}`
  }

  reset() {
    this.params = [];
  }

  addParam(blockId, name, type, position) {
    this.params.push({
      blockId,
      name,
      type,
      position
    })
  }

  getTypeByBlockId(blockId) {
    let param = this.params.find((param) => {
      return param.blockId === blockId
    })

    if (param) {
      return param.type;
    } else {
      throw new Error("No such Block ID")
    }
  }

  getNameByBlockId(blockId) {
    let param = this.params.find((param) => {
      return param.blockId === blockId
    })

    if (param) {
      return param.name;
    } else {
      throw new Error("No such Block ID")
    }
  }

  updateParams() {
    let workspace = undefined;
    const workspaces = Blockly.Workspace.getAll();
    for (let ws in workspaces) {
      if (workspaces[ws].isVisible()) {
        workspace = workspaces[ws];
      }
    }
    if (!workspace) return;

    const parent = workspace.getBlocksByType('command_definition')[0];
    let children = parent.getDescendants();

    children = children.filter((child) => {
      return child.type === 'define_param';
    });

    let remainingUsed = false;

    this.reset();
    for (let child in children) {
      let block = children[child];

      if (remainingUsed) {
        block.setEnabled(false);
        continue;
      }

      this.addParam(block.id, block.getFieldValue('Name'), block.getFieldValue('Type'), block.getFieldValue('Position'))
      block.setEnabled(true);

      if (block.getFieldValue('Position') === 'rest') {
        remainingUsed = true;
      }
    }

    parent.getField('Syntax').setValue(this.toSyntax());
    this.onUpdate(this.getParams());
  }

  getParams() {
    let workspace = undefined;
    const workspaces = Blockly.Workspace.getAll();
    for (let ws in workspaces) {
      if (workspaces[ws].isVisible()) {
        workspace = workspaces[ws];
      }
    }
    if (!workspace) return;

    const parent = workspace.getBlocksByType('command_definition')[0];
    if (!parent) return;
    let children = parent.getDescendants();

    children = children.filter((child) => {
      return child.type === 'define_param';
    });

    let remainingUsed = false;
    let result = [];

    for (let child in children) {
      let block = children[child];

      if (remainingUsed) {
        continue;
      }

      result.push({
        blockId: block.id,
        name: block.getFieldValue('Name'),
        type: block.getFieldValue('Type'),
        position: block.getFieldValue('Position')
      })

      if (block.getFieldValue('Position') === 'rest') {
        remainingUsed = true;
      }
    }

    return result
  }
}

let Params = new ParamManager();
export default Params;
